//@flow
import {
    intelliSortApi,
    bulkIntelliSortFetch,
    validateEntityIds as validateEntityIdsApi
} from 'common/middleware/api';
import PaginatedEntityActions from 'common/redux/actions/PaginatedEntityActions';
import { ToastTypes } from 'common/components/core/toast/Toast';
import { showToast } from 'common/redux/actions/toast';
import I18nHelper from 'common/helpers/I18nHelper';
import { FilterBuilder, FilterOperation } from 'common/models/internal/Filter';

import type { IntelliSortRequest } from 'common/models/internal/IntelliSortRequest';

const translationsNamespace = ['entityManagement'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

type Params = {
    selectedDate: string,
    homebases?: Array<string>
};

class IntelliSortActions extends PaginatedEntityActions<
    IntelliSortRequest,
    Params
> {
    fetchActiveEntities = (
        params: $Shape<TParams>,
        body: Object,
        options: Object
    ) => {
        if (!params.homebases) {
            return () => null;
        }
        const dateFilter = new FilterBuilder()
            .withName('date')
            .withOperation(FilterOperation.Equals)
            .withValue(params.selectedDate);
        const homebaseFilter = new FilterBuilder()
            .withName('request.homebaseId')
            .withOperation(FilterOperation.Equals)
            .withValues(params.homebases);
        let filters = [dateFilter, homebaseFilter];
        if (body.filters) {
            filters = [...filters, ...body.filters];
        }
        return this.fetchEntities(
            params,
            {
                ...body,
                filters
            },
            options
        );
    };

    updateFeedback = (
        showSuccessMessage: boolean,
        params: { clientId: string, intellisortId: string },
        feedbackStatus: string,
        value: string,
        accessor: string
    ) => {
        return (dispatch: Dispatch<*>) => {
            return new Promise((resolve, reject) => {
                const options = {
                    onSuccess: (intellisort: IntelliSortRequest) => {
                        const toast = {
                            message: nsTranslate('savedChangesMessage'),
                            type: ToastTypes.Success
                        };
                        showSuccessMessage &&
                            dispatch(showToast(toast, params));
                        resolve(intellisort);
                    },
                    onFailure: (error: Error) => {
                        reject(error);
                    },
                    dontInjectError: !showSuccessMessage
                };
                dispatch(
                    this.triggerFeedback(
                        params,
                        feedbackStatus,
                        value,
                        accessor,
                        options
                    )
                );
            });
        };
    };

    triggerFeedback = (
        params: TParams,
        feedbackStatus: string,
        value: string,
        accessor: string,
        options: SingleEntityOptionsType = {}
    ) => {
        const { processResponse, onSuccess } = options;
        return (dispatch: Dispatch<*>) => {
            dispatch(this.emitAddEntityStart(params));
            const requestBody = {
                feedbackStatus: feedbackStatus
            };
            accessor && (requestBody[accessor] = value);
            this.api
                .post(params, requestBody)
                .then((response: any) => {
                    let entity = null;
                    if (processResponse) {
                        entity = processResponse(response);
                    } else {
                        entity = (response: Object);
                    }
                    onSuccess && onSuccess(entity);
                })
                .catch((error: Error) => {
                    dispatch(this.emitAddEntityFailure(params, error));
                    this.handleError(error, options, dispatch);
                });
        };
    };
}

export default new IntelliSortActions(
    'INTELLISORT',
    intelliSortApi,
    bulkIntelliSortFetch,
    null,
    null,
    validateEntityIdsApi
);
